<coin-v2-dialog-frame [header]="newsTitle">
  <div class="main-part">
    @if (data?.type === communicationTypeEnum.Announcement) {
      <div class="announcment">
        <p>{{ data.description }}</p>
      </div>
    }
    <div class="simplebar">
      <ngx-simplebar class="primary-scrollbar-vertical equity">
        <div
          class="news"
          style="padding-right: 40px; padding-left: 40px">
          @if (cmsData) {
            <coin-all-cms-news-items
              style="padding-right: 20px"
              [item]="cmsNewsItems"
              [authService]="authService"></coin-all-cms-news-items>
          }
        </div>
        <div
          class="news"
          [hidden]="cmsData">
          <ng-template appEquityPageData></ng-template>
        </div>
      </ngx-simplebar>
    </div>
    @if (data?.type === communicationTypeEnum.News) {
      @if (filteredNewsList$ | async; as filteredNewsList) {
        <div class="news-sidebar">
          <h4>{{ 'general.other-news' | translate }}</h4>
          @if (filteredNewsList.length > 0) {
            <div>
              @for (news of filteredNewsList; track news) {
                <div
                  class="news-card"
                  (click)="setNews(news)">
                  <img
                    aria-label="topic news image"
                    class="image-wrapper"
                    [src]="news.mediaUrl || 'assets/equity/images/coin-logo-4x3.png'" />
                  <div class="title">
                    <p>{{ getLanguageContent(news)?.title }}</p>
                  </div>
                </div>
              }
            </div>
          } @else {
            <p class="bold no-news-message">{{ 'general.no-news-to-display' | translate }}</p>
          }
        </div>
      }
    }
  </div>

  <coin-v2-dialog-footer>
    <coin-v2-button
      type="secondary"
      icon="chevron_right"
      iconPos="right"
      [text]="'general.btnClose' | translate"
      (click)="close()"></coin-v2-button>
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
